import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
const getBackendUrl = () => {
  if (configuredBackendUrl) return configuredBackendUrl;

  if (typeof window !== "undefined") {
    const { origin, protocol } = window.location;
    const isLocalWeb = origin.includes("localhost") || origin.includes("127.0.0.1");
    const isNativeShell = protocol === "capacitor:" || protocol === "ionic:";
    if (origin && !isLocalWeb && !isNativeShell) return origin;
  }

  return "http://localhost:8001";
};

const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kelifa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

export const MXN = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 0 }).format(Number(n || 0));

export const formatDateMX = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  const meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  return `${parseInt(d)} ${meses[parseInt(m) - 1]} ${y}`;
};
